import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { AppRoutingModule } from '../app-routing.module';
import { PoModule } from '@po-ui/ng-components';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { AdminPanelComponent } from './admin/admin-panel/admin-panel.component';
import { ProtheusAdminComponent } from './admin/protheus-admin/protheus-admin.component';
import { SupportComponent } from './support/support.component';
import { TotvsNewsPreviewComponent } from './totvs-news-preview/totvs-news-preview.component';
import { DatabaseModule } from './database/database.module';
import { ProtheusModule } from './protheus/protheus.module';
import { QueryAnalyzerModule } from './query-analyzer/query-analyzer.module';
import { QueryChatModule } from './query-chat/query-chat.module';
import { QueryManagerModule } from './query-manager/query-manager.module';
import { JamesAdminModule } from './admin/james-admin/james-admin.module';
import { StatusComponent } from './status/status/status.component';
import { DependencyTrackModule } from './dependency-track/dependency-track.module';
import { SmartReviewModule } from "./smart-review/smart-review.module";
import { McpAdminModule } from "./admin/mcp-admin/mcp-admin.module";
import { ApiKeysModule } from "./api-keys/api-keys.module";
import { AreaTribeAdminModule } from "./admin/area-tribe-admin/area-tribe-admin.module";
import { SonarExtractorModule } from './sonar-extractor/sonar-extractor.module';

@NgModule({
  declarations: [
    MenuComponent,
    HomeComponent,
    AdminPanelComponent,
    ProtheusAdminComponent,
    SupportComponent,
    TotvsNewsPreviewComponent,
    StatusComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    PoModule,
    DatabaseModule,
    ProtheusModule,
    DependencyTrackModule,
    SonarExtractorModule,
    PoTemplatesModule,
    QueryAnalyzerModule,
    QueryChatModule,
    QueryManagerModule,
    JamesAdminModule,
    SmartReviewModule,
    McpAdminModule,
    ApiKeysModule,
    AreaTribeAdminModule,
  ],
})
export class MenuModule {}
